import { WidgetsStaffFormMain } from '@/widgets/staff-form';

export const PagesStaffNewMain = () => <WidgetsStaffFormMain mode="create" />;
